export default __webpack_public_path__ + "static/media/img_contents_banner.2ae5fbf2.png";